import React, { useState, useMemo, useRef, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
import AppRoute2 from './AppRoute2';
import Navbar from './shared/Navbar';
import Sidebar1 from './shared/sidebar1';
import Footer from './shared/Footer';
import axios from 'axios';
import FirebaseMessaging from '../app/services/FirebaseMessaging';
import { apiRequest } from './store/allApi';

import { ChatCallProvider, usePackageAuth, ChatWidget, E2eeProvider, usePushNotifications, useOriginSettings,
  openTeloChat, } from 'react-chat-call-socket';
import { chatConfig } from './chatConfig.js';




const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
const nodeMode = process.env.NODE_ENV;
const baseUrl = nodeMode === 'development' ? backendLocalApiUrl : backendLiveApiUrl;


const updatedToken = async(fcmtoken) => {
  if (window.location.pathname !== '/adminlogin') {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    
    try {
      const res = await apiRequest(`updateToken?firebaseToken=${fcmtoken}`,"GET", null,headers)
     if (res.data) {
      console.log(res);
     }
        } catch (e) {
          console.log(e);
            
        }
        finally {
        }
  }
};

function NotificationSetup({ chatUser }) {
  usePushNotifications({
    username: chatUser?.name || 'Guest',
    vapidPublicKey: chatConfig.vapidPublicKey,
    appPath: '/',
  });

  return null;
}

const App = ({ children, loggedInUser }) => {
  const [loading, setLoading] = useState(false);

  // BASE URL
   const access_token = localStorage.getItem("token");
    const profile = React.useMemo(
      () => ({
        name: loggedInUser?.name,
        mobile: loggedInUser?.mobile,
        profile_pic: loggedInUser?.avatarUrl,
      }),
      [loggedInUser]
    );
  
    const { user, token, error } =  usePackageAuth({
      apiUrl: chatConfig.apiUrl,
      apiKey: chatConfig.apiKey,
      appToken: access_token,
      userType: chatConfig.userType,
      profile,
    });
  
    const embedOrigin =
        typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.host}` : '';
    
      const { settings: originSettings } = useOriginSettings({
        apiUrl: chatConfig.apiUrl,
        apiKey: chatConfig.apiKey,
        origin: user?.origin || embedOrigin,
      });
    
      if (loading ) console.log('Connecting chat…');
      if (error) {
       console.log('Chat auth failed: {error.message || String(error)}')
      }
    
      const hideChatButton = Boolean(originSettings?.hideChatButton);
      const hideCallButton = Boolean(originSettings?.hideCallButton);
      const showLauncher = chatConfig.showLauncher !== false && !hideChatButton;

  const [tokenFirebase, setTokenFirebase] = useState('');
  const [message, setMessage] = useState('');
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);
  const [userType, setUserType] = useState('');
  const [userAname, setUserAname] = useState('');
  
  const [permission, setPermission] = useState(null);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const fetchToken = async () => {
      const tokenfirebase = await FirebaseMessaging.requestNotificationPermission();
      setTokenFirebase(tokenfirebase);
      updatedToken(tokenfirebase);
    };

    fetchToken();

    FirebaseMessaging.onMessage((payload) => {
      console.log('Message received:', payload);
      setMessage(payload.notification.body);
    });
  }, []);

  const meeApi = async() => {
    const access_token = localStorage.getItem('token')
const headers = {
  Authorization: `Bearer ${access_token}`
}
  
    if (access_token) {
      try {
        const res = await apiRequest(`admin/me_data`,"GET", null,headers)
       if (res.data) {
        setUserAname(res?.data?.Name);
        setUserType(res?.data?.user_type);
        console.log(res.data);
        let medata = res?.data;
        if (res.data?._id) {
          const access_token = localStorage.getItem('token');
          const headers = {
            Authorization: `Bearer ${access_token}`
          };
          try {
            const response = await apiRequest(`agent-permission/${res.data?._id}`,"GET", null,headers)
           if (response.data) {
               setLoading(false);
              localStorage.setItem("PData", JSON.stringify(response.data?.data));
              localStorage.setItem("uData", JSON.stringify(medata));
              // Ensure agentdashboard permission is set for agents
              const permissions = response?.data?.data;
              if (medata?.user_type === "Agent") {
                permissions.agentdashboard = true;
              }
              console.log('User permissions:', permissions);
              setPermission(permissions);
              
              // Handle redirects
              if (permissions.dashboard === true && location.pathname === '/') {
                // history.push(`/dashboard`);
              } else if (medata?.user_type === "Agent") {
                if (location.pathname !== '/dashboard/AgentDash') {
                  // history.push(`/dashboard/AgentDash`);
                }
              }
           }
              } catch (e) {
                    setLoading(false);
              console.log(e);
                  
              }
              finally {
              }
        }
  
       }
          } catch (err) {
            setLoading(false);
            if (err?.response?.status === 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('uData');
              localStorage.removeItem('PData');
              window.location.assign("/adminlogin");
            }
          }
          finally {
          }
      }
  }

  const data = async () => {
  const access_token = localStorage.getItem('token')
  const headers = {
    Authorization: `Bearer ${access_token}`
  }
    
  try {
    const res = await apiRequest(`settings/data`,"GET", null,headers)
   if (res.data) {
    localStorage.setItem("siteSetting", JSON.stringify(res.data))
   }
      } catch (e) {
        // setLoading(false)
          
      }
      finally {
      }
  
  }
  
  

  useEffect(() => {
    setLoading(true);
meeApi()
    data()
  }, [access_token]);


  const sidebarComponent = permission ? <Sidebar1 data={permission} /> : null;
  const navbarComponent = permission ? <Navbar usertype={userType} userAname={userAname} /> : null;
  const footerComponent = permission ? <Footer /> : null;

 

  return (
    <>
      {permission ? 
        <div className='container-scroller'  >
          {sidebarComponent}
          <div className='container-fluid page-body-wrapper'>
            {navbarComponent}
            <div className='main-panel'>
              <div className='content-wrapper' style={{ backgroundColor: '#fff' }}>
                <AppRoutes />
              </div>
              {footerComponent}
            </div>
          </div>
        </div> : 
        <div className='container-scroller'>
          {sidebarComponent}
          <div className='container-fluid page-body-wrapper'>
            {navbarComponent}
            <div className='main-panel' style={{ paddingTop: "0px" }}>
              <div className='content-wrapper' style={{ backgroundColor: '#fff' }}>
                <AppRoute2 />
              </div>
              {footerComponent}
            </div>
          </div>
        </div>
      }
      {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
                              ""
                            ) : JSON.parse(localStorage.getItem("sitSetting"))?.isChatSupport ===
                              true  && access_token != null? (
                              <>
                            
                              <ChatCallProvider url={chatConfig.socketUrl} token={token}>
                                            <E2eeProvider
                                              userId={user?._id}
                                              apiUrl={chatConfig.apiUrl}
                                              apiKey={chatConfig.apiKey}
                                              token={token}
                                              enabled={chatConfig.e2ee !== false}
                                            >
                                              <NotificationSetup chatUser={user} />
                                              <ChatWidget
                                                room={chatConfig.defaultRoom}
                                                username={user?.name || 'Guest'}
                                                userId={user?._id}
                                                userType={user?.user_type || chatConfig.userType}
                                                canViewDev={Boolean(user?.can_view_dev)}
                                                showLauncher={showLauncher}
                                                hideCallButton={hideCallButton}
                                                launcherHorizontal={chatConfig.launcherHorizontal || 'right'}
                                                launcherVertical={chatConfig.launcherVertical || 'bottom'}
                                                launcherOffsetYPercent={chatConfig.launcherOffsetYPercent ?? 4}
                                                launcherOffsetXPercent={chatConfig.launcherOffsetXPercent ?? 3}
                                              />
                                            </E2eeProvider>
                                          </ChatCallProvider>
                              </>
                            ) : (
                              ""
                            )}
    </>
  );
};

export default App;
